import React from 'react';
import { opsGetAllUnreadAmount } from 'api/operation';
import InboxStore from 'store/Inbox';

const useOpsMessageAllUnreadCount = (): [number | undefined, boolean, () => void] => {
    const [get, set] = InboxStore.useStore();
    const [count, setConut] = React.useState<number | undefined>(get('allUnreadCount') || undefined);
    const loading = !!get('loadingAllUnreadAmount');
    const fetchData = async () => {
        try {
            set('loadingAllUnreadAmount', true);
            const result = await opsGetAllUnreadAmount();
            if (!result.error) {
                setConut(result?.data?.data || 0);
                set('allUnreadCount', result?.data?.data || 0);
            }
            set('loadingAllUnreadAmount', false);
        } catch (e) {
            console.error(e);
            set('loadingAllUnreadAmount', false);
        }
    };
    React.useEffect(() => {
        setConut(get('allUnreadCount'));
    }, [get('allUnreadCount')]);
    React.useEffect(() => {
        if (!loading && count === undefined) {
            fetchData();
        }
    }, [loading]);

    return [count, loading, fetchData];
};

export default useOpsMessageAllUnreadCount;
